module.exports = __webpack_public_path__ + "static/media/ContextData.2c3e234b.jpg";